import axios from "axios";
import authHeader from "./auth-header";
import { NavigateFunction, useNavigate } from "react-router-dom";

const NETSTAR_API_URL = "https://gdatainfo.netstar-inc.com/api/urlrequests/";
const proxyUrl = 'https://cvhu56uroj.execute-api.us-east-1.amazonaws.com/dev/external';
const host = "gdatainfo.netstar-inc.com";
const basePath = "/api/urlrequests/";

axios.interceptors.response.use(
  res => res,
  err => {
    if(err.response.status === 401){
      localStorage.clear();
      window.location.href = '/login';
    }
    //throw new Error(err.response.data.message);
  }
)

export const getCategoriesList = () => {
  return axios.post(proxyUrl, {
    "host": host,
    "path": basePath + "jn/categories.json",
    "method": "getCategories"
  }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('access_token')
    }
  });
};
export const getUrlCategory = (url: any) => {
  return axios.post(proxyUrl, {
    "host": "signatures.juniper.net",
    "path": "/urlinfo/cat/rep?&device_id=JN12710A8JCA&srx_model=srx4600&vendor=netstar&srx_version=23.3&query_version=1.0&url="+url,
    "method": "getCategory"
  }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('access_token')
    }
  });
};
export const submitRecatRequest = (payload: any) => {
  return axios.post(proxyUrl, {
    "host": host,
    "path": basePath + "jn.json",
    "method": "submitRecatRequest",
    "payload": {
      "urlrequests": [payload],
    }
  }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('access_token')
    }
  });
};
export const getRecatRequestStatus = (req_id: string) => {
  return axios.post(proxyUrl, {
    "host": host,
    "path": basePath + 'jn/' + req_id + '.json',
    "method": "getRequestStatus"
  }, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('access_token')
    }
  });
}